import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import Navigation from "./navigation";
import GestorProvider, { GestorContext } from "./store/GestorStore";
import ReactPWAInstallProvider, {
  useReactPWAInstall,
} from "./manualPackets/react-pwa-install";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import myLogo from "./assets/logo.png";
import { polyfill } from "seamless-scroll-polyfill";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { NOME_EMPRESA } from "./config";
polyfill();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

window.addEventListener("beforeinstallprompt", (e) => {
  // Impede que o mini-infobar apareça em mobile
  e.preventDefault();
  // Guarda evento para que possa ser disparado depois.
  // Atualiza UI notifica usuário que pode instalar PWA
  // Opcionalmente, enviar eventos de analytics que promo de instalação PWA foi mostrado.
  document.getElementById("butao_legal")?.click();
});

function VerifyPWASupport() {
  const { pwaInstall, supported, isInstalled } = useReactPWAInstall() as any;

  const handleClick = () => {
    pwaInstall({
      title: "Instalar Aplicativo",
      logo: myLogo,
      featuresTitle: "Por Que instalar?",
      features: (
        <ul>
          <li>+ Rapido</li>
          <li>+ Perfomace</li>
          <li>Melhor Usabilidade</li>
          <li>Facil acesso</li>
        </ul>
      ),
      descritpionTitle: "Descrição",
      description: `Aplicativo de vendas online ${NOME_EMPRESA}`,
    })
      .then(() => alert("APP Instalado!, aproveite nosso app (づ ◕‿◕ )づ "))
      .catch(() => {return false});
  };

  return (
    <div hidden>
      <button type="button" onClick={handleClick} id="butao_legal" hidden>
        Install App
      </button>
    </div>
  );
}

root.render(
  <React.StrictMode>
    <ReactPWAInstallProvider enableLogging>
      <GestorProvider>
        <VerifyPWASupport />
        <RouterProvider router={Navigation} />
      </GestorProvider>
    </ReactPWAInstallProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();